import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import { getKeepShopping } from "../../../../Redux/ActivityApi/slice";

const dummyItems = [
  {
    _id: "",
    img: "../../assets/img/products/product-10.png",
    name: "Dolce & Gabbana's 'Greta' tote has been crafted in Italy from hard-wearing red textured-leather.",
    date: "Today",
  },
  {
    _id: "",
    img: "../../assets/img/products/product-12.png",
    name: "Dolce & Gabbana's 'Greta' tote has been crafted in Italy from hard-wearing red textured-leather.",
    date: "Yesterday",
  },
  {
    _id: "",
    img: "../../assets/img/products/product-13.png",
    name: "Dolce & Gabbana's 'Greta' tote has been crafted in Italy from hard-wearing red textured-leather.",
    date: "16-March-2026",
  },
  {
    _id: "",
    img: "../../assets/img/products/product-14.png",
    name: "Dolce & Gabbana's 'Greta' tote has been crafted in Italy from hard-wearing red textured-leather.",
    date: "14-March-2026",
  },
  {
    _id: "",
    img: "../../assets/img/products/product-17.png",
    name: "Dolce & Gabbana's 'Greta' tote has been crafted in Italy from hard-wearing red textured-leather.",
    date: "12-March-2026",
  },
  {
    _id: "",
    img: "../../assets/img/products/product-6.png",
    name: "Dolce & Gabbana's 'Greta' tote has been crafted in Italy from hard-wearing red textured-leather.",
    date: "10-March-2026",
  },
  {
    _id: "",
    img: "../../assets/img/products/product-20.png",
    name: "Dolce & Gabbana's 'Greta' tote has been crafted in Italy from hard-wearing red textured-leather.",
    date: "01-March-2026",
  },
];

const BrowsingHistoryMenu = () => {
  const dispatch = useAppDispatch();
  const { keepShopping } = useAppSelector((state) => state.activity);

  useEffect(() => {
    dispatch(getKeepShopping(7));
  }, [dispatch]);

  const itemsToDisplay = keepShopping && keepShopping.length > 0
    ? keepShopping.slice(0, 7).map((item, idx) => ({
        _id: item._id,
        img: item.mainImage,
        name: item.name,
        date: idx === 0 ? "Today" : idx === 1 ? "Yesterday" : "Recently",
      }))
    : dummyItems;

  return (
    <>
      <div>
        <div className=" mt-1 mb-3">
          <h6>
            Your browsing history{" "}
            <b className=" text-black fw-bold ms-2 text-xs">
              <a href="/BrowserHistory">View and Edit</a>
            </b>
          </h6>
        </div>
        <div className="timeline-3 overflow-sides gap-5 px-5">
          {itemsToDisplay.map((item, index) => {
            const content = (
              <div className="step" key={item._id || index} style={{ cursor: item._id ? "pointer" : "default" }}>
                <img
                  src={item.img}
                  alt="img-blur-shadow"
                  className="img-fluid-hist-pro"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.src = "/assets/img/salarlogo.png"; }}
                />
                <div className=" lh-1 history-truncate text-start">
                  <b className=" text-black text-xxs ">
                    {item.name}
                  </b>
                </div>
                <div className="circle mt-2"></div>
                <b className=" text-black fw-bold text-sm">{item.date}</b>
              </div>
            );

            return item._id ? (
              <a href={`/DetailPage/${item._id}`} key={item._id} className="text-decoration-none">
                {content}
              </a>
            ) : (
              <React.Fragment key={index}>
                {content}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default BrowsingHistoryMenu;
